import { Link } from 'react-router-dom';
import { Users, User } from 'lucide-react';
import { Friendship } from '../types/friends';
import { formatFriendDisplayName, getFriendInitial } from '../utils/friendDisplayUtils';

interface TravelingCompanionsSectionProps {
  companions: Friendship[];
  isPast?: boolean;
}

const TravelingCompanionsSection = ({ companions, isPast = false }: TravelingCompanionsSectionProps) => {
  if (companions.length === 0) return null;

  return (
    <div className="bg-gradient-to-r from-teal-50 to-blue-50 rounded-lg p-6 border border-teal-200 shadow-md">
      <div className="flex items-center gap-3 mb-4">
        <Users className="h-6 w-6 text-teal-600" />
        <h2 className="text-xl font-semibold text-gray-800">
          {isPast ? 'Traveled Together' : 'Traveling Together'}
        </h2>
      </div>
      <p className="text-sm text-gray-600 mb-4">
        {isPast
          ? `You sailed with ${companions.length} friend${companions.length > 1 ? 's' : ''} on this cruise!`
          : `You're sailing with ${companions.length} friend${companions.length > 1 ? 's' : ''} on this cruise!`}
      </p>
      <div className="space-y-2">
        {companions.map((companion) => (
          <Link
            key={companion.friendId}
            to={`/friend/${companion.friendId}/cruises`}
            className="flex items-center gap-3 p-3 bg-white rounded-lg hover:bg-teal-50 transition-colors border border-teal-100"
          >
            <div className="h-10 w-10 rounded-full bg-secondary-600 flex items-center justify-center text-white font-semibold">
              {getFriendInitial(companion)}
            </div>
            <div className="flex-1">
              <p className="font-medium text-gray-900">{formatFriendDisplayName(companion)}</p>
              <p className="text-sm text-gray-500">View their cruises</p>
            </div>
            <User className="h-5 w-5 text-teal-600" />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default TravelingCompanionsSection;

